import React from "react";
import PropTypes from "prop-types";
import { Radio, Typography } from "antd";

const { Text } = Typography;

/**
 * Selector Sí / No / Sin definir para campos opcionales de tres estados (Flota propia del vehículo,
 * Conductor propio / interno). "Sin definir" se guarda como null.
 */
const OPCIONES = [
  { valor: "si", label: "Sí" },
  { valor: "no", label: "No" },
  { valor: "sin_definir", label: "Sin definir" },
];

const aOpcion = (valor) => (valor === true || valor === 1 || valor === "1" ? "si" : valor === false || valor === 0 || valor === "0" ? "no" : "sin_definir");
const aValor = (opcion) => (opcion === "si" ? true : opcion === "no" ? false : null);

export const textoSiNoSinDefinir = (valor) => ({ si: "Sí", no: "No", sin_definir: "Sin definir" })[aOpcion(valor)];

const SiNoSinDefinir = ({ name, label, value, handleInputChange, ayuda }) => (
  <div style={{ marginBottom: 12 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 4 }}>
      <Text strong>{label}</Text>
      <Radio.Group
        optionType="button"
        buttonStyle="solid"
        size="small"
        value={aOpcion(value)}
        onChange={(e) => handleInputChange({ target: { name, value: aValor(e.target.value) } })}
        aria-label={label}
      >
        {OPCIONES.map((o) => (
          <Radio.Button key={o.valor} value={o.valor}>
            {o.label}
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
    {ayuda && (
      <Text type="secondary" style={{ fontSize: 12 }}>
        {ayuda}
      </Text>
    )}
  </div>
);

SiNoSinDefinir.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  handleInputChange: PropTypes.func.isRequired,
  ayuda: PropTypes.string,
};

export default SiNoSinDefinir;
